export default __webpack_public_path__ + "static/media/tru6.dcac5e6b.png";